import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

const onlyDigitsAndSpecialCharacters = (text) => {
  const regEx = /^[\d\-#_.]+$/
  return regEx.test(text)
}

export const CitySingaporeValidationV2: (storeId, t) => TextInputValidationFn = (storeId, t) => (text) => {
  if (storeId !== '29' || onlyDigitsAndSpecialCharacters(text)) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: t('checkout:INPUT_FIELD_ERROR_FLOOR_UNIT_NUMBER'),
    success: false,
  }
}
